export const formatNumber = (value: number, decimals = 0): string => {
  return value.toLocaleString("en-GB", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const formatPct = (value: number): string => {
  return `${value.toFixed(1)}%`;
};

export const formatPctSigned = (value: number | null): string => {
  if (value === null) return "N/A";
  const sign = value >= 0 ? "+" : "";
  return `${sign}${value.toFixed(1)}%`;
};

export const formatAvailability = (pct: number | null): string => {
  if (pct === null) return "N/A";
  if (pct === 100) return "100%";
  return `${pct.toFixed(3)}%`;
};

export const RYG_ICONS: Record<string, string> = {
  red: "\uD83D\uDD34",
  amber: "\uD83D\uDFE0",
  green: "\uD83D\uDFE2",
  // Blue indicates pending/neutral data (e.g. curtailment data not yet available).
  blue: "\uD83D\uDD35",
};

// All-cause availability (every outage docks) beside the EPC "(excused)" figure,
// which removes excused outages from the clock.
export const AVAILABILITY_TILES = [
  {
    key: "aggregateAvailability",
    label: "Aggregate PV availability",
    source: "aggregateAvailability",
    excused: false,
  },
  {
    key: "aggregateAvailabilityExcused",
    label: "Aggregate PV availability (excused)",
    source: "aggregateAvailability",
    excused: true,
  },
  {
    key: "aggregateBessAvailability",
    label: "Aggregate BESS availability",
    source: "aggregateBessAvailability",
    excused: false,
  },
  {
    key: "aggregateBessAvailabilityExcused",
    label: "Aggregate BESS availability (excused)",
    source: "aggregateBessAvailability",
    excused: true,
  },
] as const;
